import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';

export interface CardMenuItem {
  label: string;
  action: string;
}

@Component({
  selector: 'outlaw-selection-card-menu',
  templateUrl: './selection-card-menu.component.html',
  styleUrls: ['./selection-card-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkOverlayOrigin, CdkConnectedOverlay],
})
export class SelectionCardMenuComponent {
  items = input<CardMenuItem[]>([
    { label: 'Edit', action: 'edit' },
    { label: 'Delete', action: 'delete' },
  ]);
  itemClicked = output<string>();
  openChanged = output<boolean>();

  isOpen = signal(false);

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen.update(v => !v);
    this.openChanged.emit(this.isOpen());
  }

  close(): void {
    this.isOpen.set(false);
    this.openChanged.emit(false);
  }

  onItemClick(action: string, event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen.set(false);
    this.openChanged.emit(false);
    this.itemClicked.emit(action);
  }
}
